export const getFilter = (state) => state.mappings.filter;

export const getProvider = (state) => state.mappings.provider;
